module.exports = __webpack_public_path__ + "static/media/flowbuilder-room-grid.9099cec7.svg";